import Repository from './Repository';

const resource = '/comportamentos';

export default {

  getAll(mapeamento, comissao) {
    return Repository.get(`${resource}/all?mapeamento=${mapeamento}&comissao=${comissao}`);
  },

  create(mapeamento, payload) {
    return Repository.post(`${resource}/?mapeamento=${mapeamento}`, payload);
  },

  update(comissao, payload) {
    return Repository.put(`${resource}/${payload.id}?comissao=${comissao}`, payload);
  },

  consolidar(payload) {
    return Repository.put(`${resource}/normalizacao/consolidar`, payload);
  },

  vincular(payload) {
    return Repository.put(`${resource}/normalizacao/vincular`, payload);
  },

  delete(id) {
    return Repository.delete(`${resource}/${id}`);
  },
};
